'use client'

/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-floating-promises */

import React, { useEffect } from 'react'
import { pageEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import WidgetModal from '../common/widgetModal'
import styles from './rtoVehicleInfoWidgetModal.module.scss'
import ScannerDetails from '../common/scannerDetails'
import { VEHICLE_FIELDS } from './rtoVehicleInfoConfig'
import { DASH_FALLBACK, RTO_VEHICLE_INFO_WIDGET } from '../common/commonConstants'
import { SEGMENT } from '../common/widgetSegments'
import { commonWidgetConfig, vehicleTypeConfig } from '../common/commonWidgetConfig'

const RtoVehicleInfoWidgetModal = ({ vehicleData, regNo, setWidgetModal, segmentEventCommonProperties, phone, userData, setRegNo, setVehicleData }) => {
  const { model_name, fuel_type, owner_name } = vehicleData

    useEffect(() => {
        pageEvent(SEGMENT.VIEW_PAGE, {
          ...segmentEventCommonProperties,
          product: commonWidgetConfig?.product?.[RTO_VEHICLE_INFO_WIDGET],
          phone: phone || userData?.phone,
          registration_number: regNo,
          vehicle_type: vehicleTypeConfig[vehicleData?.vehicle_type_v2] || vehicleTypeConfig.DEFAULT,
          mm_name: vehicleData?.model_name,
          previous_policy_expiry_date: vehicleData?.previous_policy_expiry_detail,
        })
      }, [])

  return (
    <WidgetModal setRegNo={setRegNo} setWidgetModal={setWidgetModal} vehicleData={vehicleData} regNo={regNo} setVehicleData={setVehicleData}>
      <div className={styles.vehicleInfoContainer}>
        <div className={styles.heading}>General details</div>
        <div className={styles.vehicleDetailsContainer}>
          <div className={styles.vehicleDetails}>
            <p>{VEHICLE_FIELDS.FUEL_TYPE}</p>
            <span>{fuel_type || DASH_FALLBACK}</span>
          </div>
          <div className={styles.vehicleDetails}>
            <p>{VEHICLE_FIELDS.OWNER_NAME}</p>
            <span>{owner_name || DASH_FALLBACK}</span>
          </div>
          <div className={styles.vehicleDetails}>
            <p>{VEHICLE_FIELDS.MODEL_NAME}</p>
            <span>{model_name || DASH_FALLBACK} </span>
          </div>
        </div>
      </div>
      <ScannerDetails regNo={regNo} segmentEventCommonProperties={segmentEventCommonProperties} widgetType={RTO_VEHICLE_INFO_WIDGET} phone={phone} userData={userData} vehicleData={vehicleData} />
    </WidgetModal>
  )
}

export default RtoVehicleInfoWidgetModal
